import { API_KEY_API_URL } from './apiKeyEnum.js';
import createService from 'shared/utils/createService.js';

export default createService(API_KEY_API_URL, {
  extraMethods: {
    async revoke(apiKeyId) {
      return this.request({
        url: `${API_KEY_API_URL}${apiKeyId}/revoke/`,
        method: 'post',
      });
    },
  },
});
